export default __webpack_public_path__ + "static/media/sample.3faaa13c.jpg";